module.exports = __webpack_public_path__ + "img/navbar-item-default.8b5d103.webp";